
import { companyUrlLib } from '../ter/ter-company-utils';
import config from './config';
let urlLib = {};
let apiLib = {};

urlLib.websitePrefix = () => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE SAJT
  let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  // url = config.webisteUrlPrefix;
  // console.log('websitePrefix', url);
  /*
  if (url !== '') {
    url += '/';
  }
  */
  return url;
};

urlLib.staticFolder = () => {
  let url = '/static';
  return url;
};

urlLib.terSlika = (nazivSlike) => {
  let url = urlLib.websitePrefix() + urlLib.staticFolder() + '/ter/' + nazivSlike;
  return url;
};

// TODO za kasnije
apiLib.apiPrefix = () => {
  // API PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE API
  // let url = 'api.sajtzaapi.com'; // TODO...
  let url = config.apiUrlPrefix;
  return url;
};


// AUTHENTICATION API

apiLib.postAuthLogout = function () {
  // backend logout
  let url = apiLib.apiPrefix() + '/api/v1/auth/logout'; // POST
  return url;
};

apiLib.postAuthFormLogin = function () {
  let url = apiLib.apiPrefix() + '/api/v1/auth/formlogin'; // POST
  console.log(url)
  return url;
};

apiLib.getAuthMyUserData = () => {
  // AUTOLOGIN + USER PROFILE GET
  // let url = apiLib.apiPrefix() + '/api/v1/user/profile/get?userid=' + userid; // GET_METHOD
  let url = apiLib.apiPrefix() + '/api/v1/user/profile/get'; // GET_METHOD
  return url;
};


// USERS

apiLib.getUserList = () => {
  let url = apiLib.apiPrefix() + '/api/v1/user/list'; // GET
  return url;
};

apiLib.postUserUpdate = () => {
  let url = apiLib.apiPrefix() + '/api/v1/user/update'; // POST
  return url;
};

apiLib.postUserCreate = () => {
  let url = apiLib.apiPrefix() + '/api/v1/user/create'; // POST
  return url;
};


// DATA

// NOVO
apiLib.getComorderList = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorder/list/get'; // GET
  return url;
};
apiLib.postComorderCreate = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorder/create'; // POST
  return url;
};
apiLib.postComorderUpdate = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorder/update'; // POST
  return url;
};
apiLib.postComorderUpdateFlagDeleted = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorder/flagdeleted'; // POST
  return url;
};
apiLib.postComorderUpdateUndelete = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorder/undelete'; // POST
  return url;
};


apiLib.getComorditemList = () => {
  // lista zaglavlja virboma
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/list/get'; // GET
  return url;
};
apiLib.postComorditemCreate = () => {
  // zaglavlje projekta kreiranje
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/create'; // POST
  return url;
};
apiLib.postComorditemUpdate = () => {
  // zaglavlje projekta 
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/update'; // POST
  return url;
};
apiLib.postComorditemUpdateFlagDeleted = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/flagdeleted'; // POST
  return url;
};
apiLib.postComorditemUpdateUndelete = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/undelete'; // POST
  return url;
};
apiLib.postComorditemUpdateUntake = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/untake'; // POST
  return url;
};
apiLib.postComorditemUpdateAdminUntake = () => {
  let url = apiLib.apiPrefix() + '/api/v1/comorditem/adminuntake'; // POST
  return url;
};

// Virbom je ranije nazivan Draft (još uvek se tako zove jedan deo sastava u reduceru) a API-ji koji se bave sa Virbom-om barataju sa najmanje dve tabele u bazi virbom_header i virbom_members... a za te dve tabele je zajednicko da imaju zajednicki superkey (id revizija virboma)... Oni se takodje cuvaju kao posebne revizija ali za dobijanje najnovije published revizije, koja je virtuelni podatak, se koristi virbom_parent_id
apiLib.getVirbomSingleByParentId = (virbom_parent_id, is_read_only) => {
  // getVirbomSingleByParentId - single virbom members i zaglavlje
  let url = apiLib.apiPrefix() + '/api/v1/virbom/single/get?virbom_parent_id=' + virbom_parent_id; // GET
  if (is_read_only === true) {
    url = apiLib.apiPrefix() + '/api/v1/virbom/single/get?virbom_parent_id=' + virbom_parent_id + '&readonly=true'; // GET
  }
  return url;
};
apiLib.getVirbomRevParticular = (rev_id) => {
  // getVirbomRevParticular - single revizija particular/konkretna/oderdjena
  let url = apiLib.apiPrefix() + '/api/v1/virbom/revparticular/get?rev_id=' + rev_id; // GET
  return url;
};
apiLib.getVirbomListRevs = (rev_id) => {
  // TODO
  let url = apiLib.apiPrefix() + '/api/v1/virbom/masterandheaderrev/all/get'; // GET
  return url;
};
apiLib.getVirbomListRevsByParentId = (virbom_parent_id) => {
  // getVirbomListRevsByParentId - ?????
  let url = apiLib.apiPrefix() + '/api/v1/virbom/header/list/get?virbom_parent_id=' + virbom_parent_id; // GET
  return url;
};
apiLib.postVirbomUpdate = () => {
  // postVirbomUpdate - SUPERUPDATE svih delova projekta
  // let url = apiLib.apiPrefix() + '/api/v1/draft/superupdate'; // POST
  let url = apiLib.apiPrefix() + '/api/v1/virbom/superupdate'; // POST
  return url;
};
apiLib.postVirbomRevUpdatePublished = () => {
  // TODO
  let url = apiLib.apiPrefix() + '/api/v1/virbom/revflagpublished/update'; // POST
  return url;
};

apiLib.getGenusPpList = () => {
  let url = apiLib.apiPrefix() + '/api/v1/genus/list/get'; // GET
  return url;
};

apiLib.postGenusUpdateSmartArr = () => {
  // postGenusUpdateSmartArr
  let url = apiLib.apiPrefix() + '/api/v1/genus/updatesmartarr'; // POST
  return url;
};

/*
apiLib.postGenusUpdateSmartSingle = () => {
  // postGenusUpdateSmart
  let url = apiLib.apiPrefix() + '/api/v1/genus/updatesmartsingle'; // POST
  return url;
};
*/


apiLib.postAdminDbInitialSeed = () => {
  // postAdminDbInitialSeed
  let url = apiLib.apiPrefix() + '/api/v1/dev/admin/simbackendfdb/initialseed'; // POST
  return url;
};
apiLib.getDevDbWhole = () => {
  // postAdminDbInitialSeed
  let url = apiLib.apiPrefix() + '/api/v1/dev/admin/simbackendfdb/getdbwhole'; // POST
  return url;
};

apiLib.postAdminDbDelete = () => {
  // postAdminDbDelete
  let url = apiLib.apiPrefix() + '/api/v1/dev/admin/simbackendfdb/delete'; // POST
  return url;
};


// ADMIN PANEL API URL-s

//
apiLib.getLibTerConstsList = () => {
  // getLibVirtelParamsList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libterconsts/list/get'; // GET
  return url;
};
apiLib.getLibTerConstsListRevsByOfId = (of_id) => {
  // getLibVirtelParamsList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libterconsts/listrevs/get/' + of_id; // GET
  return url;
};


//
apiLib.getLibVirtelParamsList = () => {
  // getLibVirtelParamsList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libvirtelparams/list/get'; // GET
  return url;
};
apiLib.getLibVirtelParamsListRevsByOfId = (of_id) => {
  // getLibVirtelParamsListRevsByOfId
  let url = apiLib.apiPrefix() + '/api/v1/admin/libvirtelparams/listrevs/get/' + of_id; // GET
  return url;
};
apiLib.postLibVirtelParamsCreate = () => {
  // postLibVirtelParamsCreate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libvirtelparams/create'; // POST
  return url;
};
apiLib.postLibVirtelParamsUpdate = () => {
  // postLibVirtelParamsUpdate 
  let url = apiLib.apiPrefix() + '/api/v1/admin/libvirtelparams/update'; // POST
  return url;
};


//
apiLib.getLibMaterijalLimParamsList = () => {
  // getLibMaterijalLimParamsList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libmaterijallimparams/list/get'; // GET
  return url;
};
apiLib.getLibMaterijalLimParamsListRevsByOfId = (of_id) => {
  // TODO
  // getLibMaterijalLimParamsListRevsByOfId
  let url = apiLib.apiPrefix() + '/api/v1/admin/libmaterijallimparams/listrevs/get/' + of_id; // GET
  return url;
};
apiLib.postLibMaterijalLimParamsCreate = () => {
  // postLibMaterijalLimParamsCreate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libmaterijallimparams/create'; // POST
  return url;
};
apiLib.postLibMaterijalLimParamsUpdate = () => {
  // postLibMaterijalLimParamsUpdate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libmaterijallimparams/update'; // POST
  return url;
};


//
apiLib.getLibCparamsList = () => {
  // getLibCparamsList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcparams/list/get'; // GET
  return url;
};
apiLib.getLibCparamsListRevsByOfId = (of_id) => {
  // TODO
  // getLibCparamsListRevsByOfId
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcparams/listrevs/get/' + of_id; // GET
  return url;
};
apiLib.postLibCparamsCreate = () => {
  // postLibCparamsCreate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcparams/create'; // POST
  return url;
};
apiLib.postLibCparamsUpdate = () => {
  // postLibCparamsUpdate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcparams/update'; // POST
  return url;
};


//
apiLib.getLibCNCProgramS4TemplateList = () => {
  // getLibCNCProgramS4TemplateList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcncprograms4template/list/get'; // GET
  return url;
};
apiLib.getLibCNCProgramS4TemplateListRevsByOfId = (of_id) => {
  // getLibCNCProgramS4TemplateListRevsByOfId
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcncprograms4template/listrevs/get/' + of_id; // GET
  return url;
};
apiLib.postLibCNCProgramS4TemplateCreate = () => {
  // postLibCNCProgramS4TemplateCreate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcncprograms4template/create'; // POST
  return url;
};
apiLib.postLibCNCProgramS4TemplateUpdate = () => {
  // postLibCNCProgramS4TemplateUpdate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libcncprograms4template/update'; // POST
  return url;
};


//
apiLib.getLibDocumentList = () => {
  // getLibDocumentList
  let url = apiLib.apiPrefix() + '/api/v1/admin/libdocument/list/get'; // GET
  return url;
};
apiLib.getLibDocumentListRevsByOfId = (of_id) => {
  // TODO
  // getLibDocumentListRevsByOfId
  let url = apiLib.apiPrefix() + '/api/v1/admin/libdocument/listrevs/get/' + of_id; // GET
  return url;
};
apiLib.postLibDocumentCreate = () => {
  // postLibDocumentCreate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libdocument/create'; // POST
  return url;
};
apiLib.postLibDocumentUpdate = () => {
  // postLibDocumentUpdate
  let url = apiLib.apiPrefix() + '/api/v1/admin/libdocument/update'; // POST
  return url;
};


// EXTERNAL API

apiLib.getExternalOrdersList = () => {
  // GET liste narudzbi
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/Get/'; // GET
  // return url;
  return companyUrlLib.getExternalOrdersList();
};
apiLib.getExternalOrderDataByKey = (broj_ordera) => {
  // GET podaci o pojedinacnom orderu
  // http://api.orders.termovent.o3on.rs/api/Orders/GetByKey/1801OR0000002
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/GetByKey/' + broj_ordera; // GET
  // return url;
  return companyUrlLib.getExternalOrderDataByKey(broj_ordera);
};
apiLib.getExternalOrderFilesByKey = (broj_ordera) => {
  // GET stavke/fajlovi jednog orrdera
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/GetFilesByKey/ORDER:' + broj_ordera; // GET
  // return url;
  return companyUrlLib.getExternalOrderFilesByKey(broj_ordera);
};
apiLib.postExternalSpreadsheetUpload = () => {
  // POST export/upload sastavnice
  // https://localhost:44383/api/Spreadsheet/Post
  // http://api.orders.termovent.o3on.rs/api/Spreadsheet/Post
  // 
  // let url = 'http://api.orders.termovent.o3on.rs/api/Spreadsheet/Post'; // POST
  /*
  Poštovani,
  Promenio sam API da prihvata bilo kakva rezultat u json formatu.
  Api endpoint je https://localhost:44383/api/Spreadsheet/Post

  Metod je POST
  I parametar u koji treba da smestite JSON u tekstualnom formatu je value.
  
  Primer iz javascripta
  
  $.ajax({
    method: 'POST',
    url: 'https://localhost:44383/api/Spreadsheet/Post',
    data: { value: JSON.stringify(jsonData) }
  })
  */
  // let url = 'http://api.orders.termovent.o3on.rs/api/Spreadsheet/Post'; // POST
  // return url;
  return companyUrlLib.postExternalSpreadsheetUpload();
};
apiLib.getExternalUserById = (id) => {
  // GET podaci o pojedinacnom korisniku
  return companyUrlLib.getExternalUserById(id);
};
apiLib.getExternalBomInfoByRevId = (id) => {
  // GET dodatni info o sastavnici
  return companyUrlLib.getExternalBomInfoByRevId(id);
};
apiLib.getExternalOrderItemsByKey = (broj_ordera) => {
  // GET status stavke narudzbe
  return companyUrlLib.getExternalOrderItemsByKey(broj_ordera);
};
apiLib.getExternalOrderItemStatusList = () => {
  // GET lista statusa stavke narudzbe
  return companyUrlLib.getExternalOrderItemStatusList();
};
apiLib.getExternalRadniCenriLokacije = () => {
  // GET lista lokacija radnih centara
  return companyUrlLib.getExternalRadniCenriLokacije();
};
apiLib.getExternalRadniCenriByLokacija = (lokacija_id) => {
  // GET lista radnih centara za jednu lokaciju
  return companyUrlLib.getExternalRadniCenriByLokacija(lokacija_id);
};




export { urlLib, apiLib };